import { useMemo } from "react"
import { type CombinedError, type OperationContext, useQuery } from "urql"

import type { Location, LocationGetSuccess, Query } from "@/graphql/codegen/graphql"
import { LocationDetailsDocument } from "@/graphql/codegen/graphql"

interface UseLocationReturn {
  locationDetailsData: Location
  locationDetailsFetching: boolean
  locationDetailsError: CombinedError | undefined
  reexecuteLocationDetailsQuery: (opts?: Partial<OperationContext>) => void
}

export const useLocation = (locationId: string): UseLocationReturn => {
  const [
    { data: locationDetails, fetching: locationDetailsFetching, error: locationDetailsError },
    reexecuteLocationDetailsQuery,
  ] = useQuery<Pick<Query, "location">>({
    query: LocationDetailsDocument,
    variables: { input: { locationId } },
  })

  const locationDetailsData = useMemo(
    () => (locationDetails?.location?.get as LocationGetSuccess)?.location,
    [locationDetails]
  )

  return {
    locationDetailsData,
    locationDetailsFetching,
    locationDetailsError,
    reexecuteLocationDetailsQuery,
  }
}
